module.exports = __webpack_public_path__ + "static/img/7areaB_08.dda051e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/7areaB_08.png
// module id = 1220
// module chunks = 1